import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BaseBackResponse,
  FileId,
  STOCK_ITEM_STATUS,
  StockItemId,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.sparePart}stockitem/massupdate`;

interface BaseUpdateStockItem {
  stockItemId: StockItemId;
  fileId?: FileId;
  stockItemStatus?: STOCK_ITEM_STATUS;
  stockItemLocation?: string;
}
export interface BaseUpdateStockItemArgs {
  stockItemsToUpdate: BaseUpdateStockItem[];
}

export default async function updateMassStockItemCommand(
  payload: BaseUpdateStockItemArgs,
): Promise<void> {
  const response = await apiCall<BaseBackResponse>(ENDPOINT, {
    method: SUPPORTED_METHODS.PUT,
    json: payload,
  });

  if (response.failure) {
    throw new Error(`Got an exception trying to updateSparePartRequestLine`);
  }
}
